import React from 'react'

// Seasonal Christmas-lights decoration.
//
// De-rastered (task #67): the strand texture used to be a ~219 KB base64 PNG
// embedded inline in this SVG — the last raster-in-JS in the tree and the reason
// `data:image/png` lingered in the client chunks. It now points at a bucket-
// hosted WebP variant (assetId 2fb17f0179f3015eeb84971496bc8ad028694a6b, the
// original 2084x2084 PNG run through scripts/asset.mjs). The SVG geometry,
// filters and pattern fills are unchanged; only the raster fill moved off-JS.
//
// This is a client component (no server resolver), so it references the RELATIVE
// /assets URL: in dev it is served from public/, and in prod the /assets/*
// safety-net redirect (next.config.js, task #67) 308s it to the media bucket.
// The component is code-split (dynamic import in BF2024Hero / Shop/BF2025), so
// the texture only loads when the seasonal UI actually renders.
//
// TODO (bucket upload PENDING — reviewer to run, needs gcloud creds not available
// in the agent worktree; upload-before-commit invariant, AGENTS.md §10). The PNG
// + WebP variants are staged in public/assets/images/... and cataloged in
// content/asset-manifest.json. Upload them to gs://vrs-media before this ships:
//   gcloud storage cp "web/public/assets/images/2fb17f0179f3015eeb84971496bc8ad028694a6b-2084x2084.png" "gs://vrs-media/assets/images/2fb17f0179f3015eeb84971496bc8ad028694a6b-2084x2084.png"
//   gcloud storage cp "web/public/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-384.webp"  "gs://vrs-media/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-384.webp"
//   gcloud storage cp "web/public/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-640.webp"  "gs://vrs-media/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-640.webp"
//   gcloud storage cp "web/public/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-828.webp"  "gs://vrs-media/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-828.webp"
//   gcloud storage cp "web/public/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-1200.webp" "gs://vrs-media/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-1200.webp"
//   gcloud storage cp "web/public/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-1920.webp" "gs://vrs-media/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-1920.webp"
const LIGHTS_TEXTURE_URL =
  '/assets/images/variants/2fb17f0179f3015eeb84971496bc8ad028694a6b-1920.webp'

function ChristmasLights(props) {
  return (
    <svg width="800" height="400" viewBox="0 0 800 400" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9573_19250)">
        <g filter="url(#filter0_f_9573_19250)">
          <rect x="-422" y="290.794" width="1087.73" height="143.792" transform="rotate(-23.6761 -422 290.794)" fill="url(#pattern0_9573_19250)"/>
        </g>
        <g filter="url(#filter1_f_9573_19250)">
          <rect x="732.76" y="60.0234" width="1087.73" height="143.792" transform="rotate(174.074 732.76 60.0234)" fill="url(#pattern1_9573_19250)"/>
        </g>
        <rect x="-422" y="290.794" width="1087.73" height="143.792" transform="rotate(-23.6761 -422 290.794)" fill="url(#pattern2_9573_19250)"/>
        <rect x="732.76" y="60.0234" width="1087.73" height="143.792" transform="rotate(174.074 732.76 60.0234)" fill="url(#pattern3_9573_19250)"/>
      </g>
      <defs>
        <filter id="filter0_f_9573_19250" x="-454" y="-178" width="1117.92" height="632.482" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="16" result="effect1_foregroundBlur_9573_19250"/>
        </filter>
        <pattern id="pattern0_9573_19250" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_9573_19250" transform="matrix(0.000479847 0 0 0.00362984 0 -3.98565)"/>
        </pattern>
        <filter id="filter1_f_9573_19250" x="-396" y="-115" width="1160.76" height="319.321" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="16" result="effect1_foregroundBlur_9573_19250"/>
        </filter>
        <pattern id="pattern1_9573_19250" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_9573_19250" transform="matrix(0.000479847 0 0 0.00362984 0 -3.98565)"/>
        </pattern>
        <pattern id="pattern2_9573_19250" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_9573_19250" transform="matrix(0.000479847 0 0 0.00362984 0 -3.98565)"/>
        </pattern>
        <pattern id="pattern3_9573_19250" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_9573_19250" transform="matrix(0.000479847 0 0 0.00362984 0 -3.98565)"/>
        </pattern>
        <clipPath id="clip0_9573_19250">
          <rect width="800" height="400" fill="white"/>
        </clipPath>
        <image id="image0_9573_19250" width="2084" height="2084" preserveAspectRatio="none" xlinkHref={LIGHTS_TEXTURE_URL}/>
      </defs>
    </svg>
  )
}

export default ChristmasLights
